import '../../css/App.css'
import '../../css/PageTemplate.css'
import { useContext, useEffect, useState } from 'react'
import { AppContext } from "../context/AppContext";
import { IAddUpdateLocationForm, IAuth, IFormFieldsValid } from '../../interfaces/interface';
import { IMessageSender, IMessageErrorResponse } from '../../interfaces/messageInterface';
import {  IErrorList, } from '../../interfaces/popMessageInterface';
import PopMessage from '../PopMessage/PopMessage';
import axios from 'axios';
import HeaderTemplate from '../HeaderTemplate';
import AddUpdateLocationForm from './AddUpdateLocationForm';
import { AddUpdateLocationContext } from '../context/AddUpdateLocationContext';

function AddUpdateLocation() {
  
    const { navBarStatus, authorization, disMessage, navBarHandler, errorHandlerFunction } = useContext(AppContext);
    const { Form, formVal, FileData  } = useContext(AddUpdateLocationContext); 
    const [ auth ]: IAuth[] = authorization;
    const [isNavbarOpen] = navBarStatus;
    const navBarClickHandler: (e: any) => void = navBarHandler;
    const [displayMessage]: string[] = disMessage;
    const [,setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
    const [formInput]:IAddUpdateLocationForm[] = Form;
    const [, setFormInput]:React.Dispatch<React.SetStateAction<IAddUpdateLocationForm>>[] = Form;
    const [, setFile]: React.Dispatch<React.SetStateAction<File | undefined>>[] = FileData;
    const [, setFormFieldsValid]:React.Dispatch<React.SetStateAction<IFormFieldsValid>>[] = formVal;
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [messageStatus, setMessageStatus] = useState<boolean>(false);
    const [errorList, setErrorList] = useState<IErrorList[]>([]);
    const errorHandler: (status: number) => string = errorHandlerFunction;

    const addUpdateLocationHandler = (): void => {
        let messageBody:IMessageSender  = {
        type: 'locationBulkLoad',
        userId: auth.username,
        locationInfo: {
            geoJson: formInput.fileData,
            locationType: formInput.locationType
            }
        }
        setDisplayMessage("processing");
        axios.post('/message',messageBody, auth.header
        ).then(res => {
        if(res.data.status === "OK"){
            setMessageStatus(true);
            if(res.data.errorList && res.data.errorDescription){
                setErrorMessage(res.data.errorDescription)
                setErrorList(res.data.errorList)
                setDisplayMessage("add-update-location-error");

            }
            clearFields(); 
        }else{        
            setMessageStatus(false);
            setErrorMessage(res.data.errorDescription)
            if(res.data.errorList){
                setErrorList(res.data.errorList)
            }
            setDisplayMessage("add-update-location-error");
        }
        }).catch(({response}:IMessageErrorResponse) => {
            const errorMessage = errorHandler(response.data.status)
            setErrorMessage(errorMessage)
            setDisplayMessage("error");
          })
    }
    const clearFields = () => {
        setFormInput({
            fileData: "",
            fileNamesList: [],
            locationType: "",
          });
        setFile(undefined);  
        setFormFieldsValid({
            isValid: false,
            displayMessage: false,
            message: ""
        });
    }

    return (
        <div className='page-template' onClick={navBarClickHandler}>
            <HeaderTemplate title="Load Polygons from File" />
            <div className={(displayMessage !== "none" || isNavbarOpen === true)?'page-template-main blur': 'page-template-main'} onClick={navBarClickHandler}>
            <AddUpdateLocationForm />
            </div>
            {displayMessage !== "none" && 
                <div className='page-template-pop-message'>
                <PopMessage 
                    assetHandler={addUpdateLocationHandler}
                    formData={{fileNamesList:formInput.fileNamesList}}
                    type={formInput.locationType}
                    error={errorMessage}
                    errorList={errorList}
                    messageStatus={messageStatus}
                />
                </div>
            }
        </div>
    );
}

export default AddUpdateLocation;
